var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cargo-advance-search quotation-client-search",
      staticStyle: { height: "auto", width: "100%" }
    },
    [
      _c("div", { staticClass: "cargo-advance-search-header" }, [
        _c("div", { staticClass: "cargo-advance-search-quick" }, [
          _c(
            "div",
            { staticClass: "section form-row" },
            [
              _c(
                "el-form",
                {
                  staticStyle: { width: "100%" },
                  attrs: { "label-position": "left", "label-width": "75px" }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.ClientName") } },
                            [
                              _c("el-input", {
                                attrs: { no: "name" },
                                model: {
                                  value: _vm.filter.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "name", $$v)
                                  },
                                  expression: "filter.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("Pricing.Owner") } },
                            [
                              _c("cargo-user-select", {
                                staticStyle: { width: "170px" },
                                attrs: {
                                  no: "category",
                                  "method-params": {
                                    category: "role",
                                    shape: "sales"
                                  },
                                  "default-value": _vm.filter.ownerId || ""
                                },
                                on: {
                                  change: function(p) {
                                    _vm.filter.ownerId = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          {
            ref: "searchOperations",
            staticClass: "cargo-advance-search-operations",
            staticStyle: { "margin-top": "10px", "margin-bottom": "10px" }
          },
          [
            _c(
              "el-button",
              {
                attrs: { no: "toQuery", type: "primary" },
                on: { click: _vm.toQuery }
              },
              [_vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_Query")) + " ")]
            ),
            _c(
              "el-button",
              {
                attrs: { no: "resetSearch", type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.resetSearch()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Reset")))]
            ),
            _vm._t("operations")
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }